<template>
  <div id="page-content" tabindex="-1">
    <span
      aria-label="Welcome Page"
      aria-live="polite"
      role="contentinfo"
    ></span>
    <h2
      class="public-h5 font-weight-bold mt-5 mb-5"
      :class="isRTLLanguage ? 'rtl' : 'normal'"
    >
      {{ siteText.ui.welcome }}
    </h2>
    <v-card>
      <v-card-text :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ siteText.ui.languageInstruction }}
      </v-card-text>
      <v-card-text class="centerContainer">
        <v-row>
          <opus-select-only-drop-down
            :items="languages"
            select-name="languageSelect"
            item-label="Name"
            item-id="Code"
            :label="siteText.ui.languageLabel"
            :place-holder="siteText.ui.languageLabel"
            aria-label="Select a Language"
            @item:selected="languageChange"
            v-model="language"
            :class="isRTLLanguage ? 'rtl' : 'normal'"
          >
            <template #item="{ Code, Name }">
              <span :lang="Code">{{ Name }}</span>
            </template>
          </opus-select-only-drop-down>
        </v-row>
      </v-card-text>
    </v-card>
    <p></p>
    <v-card>
      <v-card-text :class="isRTLLanguage ? 'rtl' : 'normal'">
        {{ siteText.ui.selectOptionInstruction }}
        <!-- Please select an option. Choose to:
        <ul>
          <li>Make a new reservation</li>
          <li>View an existing reservation (date, time, location)</li>
          <li>Cancel an existing reservation (if you have multiple services scheduled, you will be cancelling all services)</li>
          <li>Reschedule and existing reservation (change date or location)</li>
        </ul> -->
      </v-card-text>
      <v-card-text
        class="centerContainer"
        :class="isRTLLanguage ? 'rtl' : 'normal'"
      >
        <v-layout row wrap>
          <v-flex md3>
            <!-- <v-card-text>{{ siteText.ui.newReservationInstruction }}</v-card-text> -->
            <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="290px"
              @click="newReservation()"
            >
              {{ siteText.ui.newReservation }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3>
            <!-- <v-card-text>{{ siteText.ui.viewReservationInstruction }}</v-card-text> -->
            <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="290px"
              @click="viewReservation()"
            >
              {{ siteText.ui.viewReservation }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3>
            <!-- <v-card-text>{{ siteText.ui.cancelReservationInstruction }}</v-card-text> -->
            <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="290px"
              @click="cancelReservation()"
            >
              {{ siteText.ui.cancelReservation }}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md3>
            <!-- <v-card-text>{{ siteText.ui.rescheduleReservationInstruction}}</v-card-text> -->
            <v-btn
              class="ma-2 dmv-btn"
              height="45px"
              width="290px"
              @click="rescheduleReservation()"
            >
              {{ siteText.ui.rescheduleReservation }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import common from "../Utilities/common";
import OpusSelectOnlyDropDown from "@/components/OpusSelectOnlyDropDown.vue";
import nyApi from "@/api/nyApi";
export default {
  name: "WelcomePage",
  data: () => ({
    language: { Name: "English", Code: "en" },
  }),
  components: {
    OpusSelectOnlyDropDown,
  },
  computed: {
    ...mapGetters(["siteText"]),
    ...mapGetters(["languages", "isRTLLanguage","testSiteCode"]),
    ...mapGetters({ languageGetter: "language" }),
  },
  mounted() {
    //Set language based on current selected langauge//
    if (this.languages && this.languages.length > 0) {
      this.language = this.languages.find((e) => e.Code == this.languageGetter);
    }
     
    this.clearSelectedServices();
    this.clearNewAppointmentData();
    this.clearExistingAppointmentData();
    this.clearUserSelections();
    common.updateSelectAriaLabel(
      this.$refs.langaugeSelect,
      "Please selected your prefered language"
    );
    
    nyApi.ClearAuthToken();
  },
  methods: {
    ...mapActions(["setLanguage"]),
    ...mapActions({
      languageAction: "language",
      reservationOptionAction: "reservationOption",
      previousPageAction: "previousPage",
    }),
    ...mapActions("selectedService", {
      clearSelectedServices: "clearSelectedServices",
    }),
    ...mapActions([
      "clearNewAppointmentData",
      "clearExistingAppointmentData",
      "clearUserSelections",
    ]),
    ...mapActions(["getLocaleSpecificServiceTypes"]),
    // nextPage() {
    //   this.$emit('navigateTo', 'DataColllectionPage');
    // },
    async newReservation() {
      // eslint-disable-next-line no-undef
      // grecaptcha.enterprise.execute();
      this.$emit("navigateTo", "NewReservationPage", {
        pageName: "Schedule a Reservation",
      });
      console.log("newReservation");
    },
    async viewReservation() {
      this.reservationOptionAction({ value: "view" });
      this.$emit("navigateTo", "DataCollectionPage", {
        header: this.siteText.ui.viewReservationHeader,
        subHeader: this.siteText.ui.viewReservationSubHeader,
        subHeader2: this.siteText.ui.viewReservationSubHeader2,
        pageName: "View Your Reservation",
      });
      console.log("viewReservation");
    },
    async cancelReservation() {
      this.reservationOptionAction({ value: "cancel" });
      this.previousPageAction({ value: "WelcomePage" });
      this.$emit("navigateTo", "DataCollectionPage", {
        header: this.siteText.ui.cancelReservationHeader,
        subHeader: this.siteText.ui.cancelReservationSubHeader,
        subHeader2: this.siteText.ui.cancelReservationSubHeader2,
        pageName: "Cancel Your Reservation",
      });
      console.log("cancelReservation");
    },
    async rescheduleReservation() {
      this.reservationOptionAction({ value: "reschedule" });
      this.$emit("navigateTo", "DataCollectionPage", {
        header: this.siteText.ui.rescheduleReservationHeader,
        subHeader: this.siteText.ui.rescheduleReservationSubHeader,
        subHeader2: this.siteText.ui.rescheduleReservationSubHeader2,
        pageName: "Reschedule Your Reservation",
      });
      console.log("rescheduleReservation");
    },
    languageChange() {
      console.log(this.language.Code);
      this.languageAction({ value: this.language.Code });
    },
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
